import { type ReactNode } from 'react';
import { useRefetchFeedback } from './useRefetchFeedback';

type RefetchContentProps = {
  children: ReactNode;
  loading: boolean;
  className?: string;
};

const RefetchContent = ({ children, loading, className = '' }: RefetchContentProps) => {
  const feedbackVisible = useRefetchFeedback(loading);
  const contentAttributes = feedbackVisible ? { inert: '' } : {};
  return (
    <div
      aria-busy={loading}
      className={`metronic-card ${feedbackVisible ? 'metronic-card--loading' : ''} ${className}`}
    >
      {feedbackVisible ? <span aria-hidden="true" className="metronic-card-progress" /> : null}
      <div className="metronic-card-content" {...contentAttributes}>
        {children}
      </div>
    </div>
  );
};

export default RefetchContent;
